import type { AppRepository } from './repositoryTypes'

// Schedule only after settlement: slow Apps Script calls never accumulate.
export function startTeacherPolling(repository: Pick<AppRepository, 'refreshTeacher' | 'pollTeacher' | 'getSnapshot'>, options: { hidden: () => boolean; selectedSession: () => string | undefined }) {
  let stopped = false
  let initialized = false
  let failures = 0
  let timer: ReturnType<typeof setTimeout> | undefined
  const run = async () => {
    const started = Date.now()
    try {
      if (!initialized) { await repository.refreshTeacher(); initialized = true }
      else await repository.pollTeacher(options.selectedSession())
      failures = 0
    } catch { failures++ } // Repository exposes the error to the UI.
    if (stopped) return
    const sessions = repository.getSnapshot().sessions
    const live = sessions.some((session) => session.status === 'ACTIVE' || (session.id === options.selectedSession() && session.status === 'REVIEW'))
    const interval = options.hidden() ? 15_000 : live ? 1500 : 5000
    const delay = failures ? Math.min(30_000, Math.max(interval, 1500 * 2 ** failures)) : Math.max(250, interval - (Date.now() - started))
    timer = setTimeout(() => { void run() }, delay)
  }
  void run()
  return () => { stopped = true; if (timer) clearTimeout(timer) }
}
